module.exports = __webpack_public_path__ + "img/uid-token-btn.6913ef03.png";